<script>
  import {
    Button,
    Flex,
    Modal,
    TextField,
    Form,
    Submit,
  } from "@gl/design-system";
  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();
  import { _ } from "../stores/index";

  export let handleYes;
  export let title = "Confirm";
  export let yes = $_("buttons.delete");
  export let no = $_("buttons.cancel");
  export let confirmStatus = null;
  export let active;

  export let confirmationValue;

  let loading = false;
  let inputValue = "";

  $: isConfirmDisabled = confirmationValue && inputValue !== confirmationValue;

  function validateConfirmationInput(value) {
    const result = value === confirmationValue;
    return [result, $_("deletion.confirmation.error")];
  }

  async function onYes() {
    loading = true;

    try {
      await handleYes();

      dispatch("close");
    } finally {
      loading = false;
    }
  }

  function onNo() {
    dispatch("close");
  }
</script>

<Modal bind:active on:close boxed>
  <div class="gl-title mb-4">
    {title}
  </div>

  <slot />

  <Form validationMode="eager">
    {#if confirmationValue}
      <TextField
        bind:value={inputValue}
        validate={(value) => validateConfirmationInput(value)}
        placeholder={confirmationValue}
      />
    {/if}
    <Flex class="mt-6 justify-content-start">
      <Submit
        on:submit={onYes}
        {loading}
        disabled={isConfirmDisabled}
        status={confirmStatus ?? "error"}
        class="mr-3"
        label={yes}
      />
      <Button on:click={onNo} outlined disabled={loading}>{no}</Button>
    </Flex>
  </Form>
</Modal>
